// SiteUp: rótulos amigáveis (PT-BR) das tools do Captain. FONTE ÚNICA, usada tanto
// pelo indicador "IA pensando" ao vivo (CaptainProcessingIndicator.vue) quanto pelo
// rodapé persistente de tools sob a bolha da IA (components-next/message/Message.vue).
// Mantém os dois consistentes. Sem entrada no mapa → humaniza (snake_case → palavras).
export const TOOL_LABELS = {
  calculate_economy: 'Calculando economia',
  calculator: 'Calculando',
  move_kanban_stage: 'Movendo no funil',
  update_lead_info: 'Atualizando dados do lead',
  update_conversation_info: 'Atualizando dados da conversa',
  update_priority: 'Ajustando prioridade',
  send_material: 'Enviando material',
  attach_offer: 'Anexando oferta',
  offer_catalog: 'Consultando ofertas',
  generate_image: 'Gerando imagem',
  schedule_appointment: 'Agendando reunião',
  faq_lookup: 'Consultando base de conhecimento',
  search_documentation: 'Consultando base de conhecimento',
  lookup_cep: 'Consultando CEP',
  lookup_cnpj: 'Consultando CNPJ',
  web_fetch: 'Consultando site',
  http: 'Consultando serviço externo',
  extract_bill: 'Lendo a conta de luz',
  handoff: 'Transferindo atendimento',
  transfer_to_assistant: 'Transferindo atendimento',
  resolve_conversation: 'Encerrando conversa',
  add_label_to_conversation: 'Etiquetando conversa',
  add_private_note: 'Anotando',
  add_contact_note: 'Anotando no contato',
  check_messaging_window: 'Verificando janela de atendimento',
  get_lead_score: 'Avaliando o lead',
  get_purchase_history: 'Consultando histórico de compras',
  get_working_hour: 'Verificando horário de atendimento',
  get_working_hours: 'Verificando horário de atendimento',
  schedule_follow_up: 'Agendando follow-up',
  mark_do_not_contact: 'Marcando não perturbe',
  cancel_appointment: 'Cancelando agendamento',
  reschedule_appointment: 'Remarcando agendamento',
  list_appointments: 'Consultando a agenda',
  clinicorp_book_appointment: 'Agendando no sistema da clínica',
  validate_plus_contract_data: 'Conferindo dados do contrato',
  send_plus_contract: 'Emitindo contrato',
};

export const TOOL_RESULT_CODE_LABELS = {
  missing_data: 'dado faltando',
  invalid_data: 'dado inválido',
  material_unavailable: 'material indisponível',
  attachment_not_found: 'sem anexo',
  attachment_unavailable: 'anexo indisponível',
  vision_unavailable: 'leitura indisponível',
  delivery_failed: 'envio falhou',
  payment_not_current: 'pagamento em atraso',
};

const FIELD_LABELS = {
  nome_titular: 'nome',
  cpf: 'CPF/CNPJ',
  email: 'e-mail',
  telefone: 'telefone',
  uc: 'UC',
  endereco: 'endereço',
  consumo_kwh: 'consumo',
  valor_conta: 'valor',
  pagamento_em_dia: 'pagamento em dia',
  data_nascimento: 'nascimento',
  representante: 'representante',
};

const normalizeToolKey = tool =>
  String(tool)
    .split(/--|::|\./)
    .pop()
    .toLowerCase();

// Normaliza o nome cru (tira namespaces tipo `captain--tools--x` / `Captain::Tools::X`,
// baixa pra minúsculo) e mapeia pro rótulo PT-BR; sem mapeamento, humaniza.
export const labelForTool = tool => {
  const key = normalizeToolKey(tool);
  return TOOL_LABELS[key] || key.replace(/_/g, ' ');
};

// Rodapé da bolha: prefer results (com código/campo) e cai no nome da tool.
export const labelForToolTrace = (calls = [], results = []) => {
  const byId = new Map();
  (Array.isArray(results) ? results : []).forEach(result => {
    if (!result || typeof result !== 'object') return;
    const id = normalizeToolKey(result.id || result.name);
    if (!id) return;
    byId.set(id, result);
  });

  const ids = [
    ...new Set([
      ...(Array.isArray(calls) ? calls.map(normalizeToolKey) : []),
      ...byId.keys(),
    ]),
  ].filter(Boolean);

  return ids.map(id => {
    const base = labelForTool(id);
    const result = byId.get(id);
    if (!result || result.success === true) return base;

    const code = String(result.code || '');
    const field =
      result.missing_field ||
      (Array.isArray(result.missing_fields) && result.missing_fields[0]);
    const codeLabel =
      TOOL_RESULT_CODE_LABELS[code] ||
      (code ? code.replace(/_/g, ' ') : 'falhou');
    const fieldLabel = field
      ? FIELD_LABELS[field] || String(field).replace(/_/g, ' ')
      : null;
    return fieldLabel
      ? `${base} (${codeLabel}: ${fieldLabel})`
      : `${base} (${codeLabel})`;
  });
};
